import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function DevicesTableRowSkeleton({ index }) {
    return (
        <tr key={index}>
            <td>
                <Skeleton variant="rectangular" width={18} height={18} />
            </td>
            <td className="oct_cell-host">
                <Skeleton variant="text" width="60%" height={24} />
            </td>
            <td className="oct_cell-ip">
                <Skeleton variant="text" width="50%" height={24} />
            </td>
            <td className="oct_cell-status">
                <div className="oct_status-indicator">
                    <Skeleton variant="circular" width={10} height={10} className="oct_skeleton-margin-right-8" />
                    <Skeleton variant="text" width="80px" height={24} />
                </div>
            </td>
            <td className="oct_cell-compliant">
                <div className="oct_compliant-wrapper">
                    <Skeleton variant="text" width="40px" height={24} className="oct_skeleton-margin-right-8" />
                    <div className="oct_compliant-bar-container">
                        <Skeleton variant="rectangular" width="100%" height={6} className="oct_skeleton-radius-3" />
                    </div>
                </div>
            </td>
            <td>
                <div className="w-35">
                    <Skeleton variant="rectangular" width={40} height={20} className="oct_skeleton-radius-10" />
                </div>
            </td>
            <td>
                <button className="oct_dropdown-trigger-v2 oct_skeleton-dropdown-btn" disabled>
                    <Skeleton variant="circular" width={24} height={24} />
                </button>
            </td>
        </tr>
    );
}

export default DevicesTableRowSkeleton;
